export const BOOLEAN_LABEL = {
	YES: 'TAK',
	NO: 'NIE',
};
